/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/token';
import '../waiter/data';
import './creator_details';
import './types';
import '../items/items';
import './tender';
import './card_data';
import './employee';
import '../omg/model/orders';
import '../waiter/private/extensions';
import '../billing/data';
import '../connect/v2/common/tax_category';
import '../merchant/api';
import './translated_name';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bills": {
        "nested": {
          "Cart": {
            "fields": {
              "catalogVersion": {
                "type": "squareup.bills.Cart.CatalogVersion",
                "id": 6,
                "rule": "optional"
              },
              "lineItems": {
                "type": "squareup.bills.Cart.LineItems",
                "id": 1,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.Cart.Amounts",
                "id": 2,
                "rule": "optional"
              },
              "returnLineItems": {
                "type": "squareup.bills.Cart.ReturnLineItems",
                "id": 7,
                "rule": "repeated"
              },
              "amountDetails": {
                "type": "squareup.bills.Cart.AmountDetails",
                "id": 8,
                "rule": "optional"
              },
              "featureDetails": {
                "type": "squareup.bills.Cart.FeatureDetails",
                "id": 3,
                "rule": "optional"
              },
              "readOnlyCustomNote": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "groupToken": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "createdByUnitToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "returnType": {
                "type": "squareup.bills.Cart.ReturnType",
                "id": 11,
                "rule": "optional"
              }
            },
            "nested": {
              "CatalogVersion": {
                "values": {
                  "UNKNOWN": 0,
                  "COGS_CATALOG": 1,
                  "MERCHANT_CATALOG": 2
                }
              },
              "LineItems": {
                "fields": {
                  "itemization": {
                    "type": "squareup.bills.Itemization",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "fee": {
                    "type": "squareup.bills.FeeLineItem",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "discount": {
                    "type": "squareup.bills.DiscountLineItem",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "roundingAdjustment": {
                    "type": "squareup.bills.RoundingAdjustmentLineItem",
                    "id": 4,
                    "rule": "optional"
                  },
                  "defaultDiningOption": {
                    "type": "squareup.bills.DiningOptionLineItem",
                    "id": 5,
                    "rule": "optional"
                  },
                  "compItemization": {
                    "type": "squareup.bills.Itemization",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "voidItemization": {
                    "type": "squareup.bills.Itemization",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "surcharge": {
                    "type": "squareup.bills.SurchargeLineItem",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "itemizationGroups": {
                    "type": "squareup.bills.ItemizationGroup",
                    "id": 9,
                    "rule": "repeated"
                  }
                }
              },
              "Amounts": {
                "fields": {
                  "totalMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "discountMoney": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "surchargeMoney": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ReturnLineItems": {
                "fields": {
                  "sourceBillTokenPair": {
                    "type": "squareup.common.token.TokenPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "returnItemization": {
                    "type": "squareup.bills.Cart.ReturnLineItems.ReturnItemization",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "discountLineItem": {
                    "type": "squareup.bills.DiscountLineItem",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "feeLineItem": {
                    "type": "squareup.bills.FeeLineItem",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "roundingAdjustment": {
                    "type": "squareup.bills.RoundingAdjustmentLineItem",
                    "id": 5,
                    "rule": "optional"
                  },
                  "returnTipLineItem": {
                    "type": "squareup.bills.ReturnTipLineItem",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "returnSurchargeLineItem": {
                    "type": "squareup.bills.ReturnSurchargeLineItem",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "itemizationGroups": {
                    "type": "squareup.bills.ItemizationGroup",
                    "id": 8,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ReturnItemization": {
                    "fields": {
                      "sourceItemizationTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemization": {
                        "type": "squareup.bills.Itemization",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "AmountDetails": {
                "fields": {
                  "return": {
                    "type": "squareup.bills.Cart.Amounts",
                    "id": 1,
                    "rule": "optional"
                  },
                  "net": {
                    "type": "squareup.bills.Cart.Amounts",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeatureDetails": {
                "fields": {
                  "pickupOrder": {
                    "type": "squareup.bills.Cart.FeatureDetails.PickupOrder",
                    "id": 1,
                    "rule": "optional"
                  },
                  "openTicket": {
                    "type": "squareup.bills.Cart.FeatureDetails.OpenTicket",
                    "id": 2,
                    "rule": "optional"
                  },
                  "invoice": {
                    "type": "squareup.bills.Cart.FeatureDetails.Invoice",
                    "id": 3,
                    "rule": "optional"
                  },
                  "kitchenPrinting": {
                    "type": "squareup.bills.Cart.FeatureDetails.KitchenPrinting",
                    "id": 4,
                    "rule": "optional"
                  },
                  "buyerInfo": {
                    "type": "squareup.bills.Cart.FeatureDetails.BuyerInfo",
                    "id": 5,
                    "rule": "optional"
                  },
                  "appointmentsDetails": {
                    "type": "squareup.bills.Cart.FeatureDetails.AppointmentsDetails",
                    "id": 6,
                    "rule": "optional"
                  },
                  "availableInstrumentDetails": {
                    "type": "squareup.bills.Cart.FeatureDetails.InstrumentDetails",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "order": {
                    "type": "squareup.bills.Cart.FeatureDetails.Order",
                    "id": 8,
                    "rule": "optional"
                  },
                  "coursingOptions": {
                    "type": "squareup.bills.Cart.FeatureDetails.CoursingOptions",
                    "id": 9,
                    "rule": "optional"
                  },
                  "seating": {
                    "type": "squareup.bills.Cart.FeatureDetails.Seating",
                    "id": 10,
                    "rule": "optional"
                  },
                  "billPrintState": {
                    "type": "squareup.bills.Cart.FeatureDetails.BillPrintState",
                    "id": 11,
                    "rule": "optional"
                  },
                  "reopenDetails": {
                    "type": "squareup.bills.Cart.FeatureDetails.ReopenDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "coverCountChangeLog": {
                    "type": "squareup.bills.Cart.FeatureDetails.CoverCountEvent",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "authAndDelayedCapture": {
                    "type": "squareup.bills.Cart.FeatureDetails.AuthAndDelayedCapture",
                    "id": 14,
                    "rule": "optional"
                  },
                  "lifecycleEvent": {
                    "type": "squareup.bills.Cart.FeatureDetails.LifecycleEvent",
                    "id": 15,
                    "rule": "repeated"
                  },
                  "pricingEngineState": {
                    "type": "squareup.bills.Cart.FeatureDetails.PricingEngineState",
                    "id": 16,
                    "rule": "optional"
                  },
                  "buyerNotificationDetails": {
                    "type": "squareup.bills.Cart.FeatureDetails.BuyerNotificationDetails",
                    "id": 17,
                    "rule": "optional"
                  },
                  "channels": {
                    "type": "squareup.bills.Cart.FeatureDetails.Channel",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "waiterFeatureDetailsExtension": {
                    "type": "squareup.waiter.data.WaiterFeatureDetailsExtension",
                    "id": 28250,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PickupOrder": {
                    "fields": {
                      "note": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "OpenTicket": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "note": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ticketTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 3,
                        "rule": "optional"
                      },
                      "ticketOwner": {
                        "type": "squareup.bills.CreatorDetails",
                        "id": 4,
                        "rule": "optional"
                      },
                      "predefinedTicket": {
                        "type": "squareup.bills.Cart.FeatureDetails.OpenTicket.PredefinedTicket",
                        "id": 5,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "squareup.bills.ISO8601Date",
                        "id": 7,
                        "rule": "optional"
                      },
                      "productsOpenedOn": {
                        "type": "squareup.bills.Cart.FeatureDetails.OpenTicket.OpenTicketProductAssociation",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "createdDeviceInfo": {
                        "type": "squareup.bills.Cart.FeatureDetails.OpenTicket.CreatedDeviceInfo",
                        "id": 9,
                        "rule": "optional"
                      },
                      "usingCommitments": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "createdByFirstTableTouch": {
                        "type": "bool",
                        "id": 12,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "reservationInformation": {
                        "type": "squareup.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation",
                        "id": 13,
                        "rule": "optional"
                      },
                      "vectorClockVersion": {
                        "type": "int64",
                        "id": 14,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PredefinedTicket": {
                        "fields": {
                          "ticketGroup": {
                            "type": "squareup.api.items.TicketGroup",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ticketTemplate": {
                            "type": "squareup.api.items.TicketTemplate",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "OpenTicketProductAssociation": {
                        "values": {
                          "DO_NOT_SET": 0,
                          "RESTAURANT_POS": 1,
                          "RETAIL_POS": 2,
                          "SQUARE_POS": 3,
                          "APPOINTMENTS_POS": 4
                        }
                      },
                      "CreatedDeviceInfo": {
                        "fields": {
                          "deviceName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceCredentialName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "deviceCredentialToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "ReservationInformation": {
                        "fields": {
                          "guestFirstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "guestLastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "partySize": {
                            "type": "uint32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "occasions": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "guestRelationships": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "providerName": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "guestDiningPreferences": {
                            "type": "string",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "guestSeatingPreferences": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "reservationNotes": {
                            "type": "squareup.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes",
                            "id": 9,
                            "rule": "optional"
                          },
                          "reservationTime": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "reservationId": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "tags": {
                            "type": "string",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "providerReservationId": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "deposit": {
                            "type": "squareup.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit",
                            "id": 14,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ReservationNotes": {
                            "fields": {
                              "guestGeneralNote": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "guestDiningPreferencesNote": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "guestSpecialRelationshipNote": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "venueNote": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "guestRequest": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "guestSeatingPreferencesNote": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          },
                          "Deposit": {
                            "fields": {
                              "depositAmount": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "paymentId": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "Invoice": {
                    "fields": {
                      "invoiceTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "version": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "isFinalPayment": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "associatedOrder": {
                        "type": "squareup.bills.Cart.FeatureDetails.Invoice.AssociatedOrder",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AssociatedOrder": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "KitchenPrinting": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "InstrumentDetails": {
                    "fields": {
                      "instrumentToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayDetails": {
                        "type": "squareup.bills.Cart.FeatureDetails.InstrumentDetails.DisplayDetails",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DisplayDetails": {
                        "fields": {
                          "cardholderName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastFour": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "brand": {
                            "type": "squareup.bills.CardTender.Card.Brand",
                            "id": 3,
                            "rule": "optional"
                          },
                          "expiry": {
                            "type": "squareup.bills.CardData.KeyedCard.Expiry",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "BuyerInfo": {
                    "fields": {
                      "customerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayDetails": {
                        "type": "squareup.bills.Cart.FeatureDetails.BuyerInfo.DisplayDetails",
                        "id": 2,
                        "rule": "optional"
                      },
                      "availableInstrumentDetails": {
                        "type": "squareup.bills.Cart.FeatureDetails.InstrumentDetails",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "customerGroups": {
                        "type": "string",
                        "id": 4,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "DisplayDetails": {
                        "fields": {
                          "displayName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastVisit": {
                            "type": "squareup.bills.ISO8601Date",
                            "id": 2,
                            "rule": "optional"
                          },
                          "email": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "phoneNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "phoneToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "loyaltyAccountPhoneToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "AppointmentsDetails": {
                    "fields": {
                      "appointmentId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "appointmentStaff": {
                        "type": "squareup.bills.CreatorDetails",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Order": {
                    "fields": {
                      "orderTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "referenceId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "displayedOrderReference": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "SourceTicketInformation": {
                    "fields": {
                      "clientId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CoursingOptions": {
                    "fields": {
                      "course": {
                        "type": "squareup.bills.Cart.FeatureDetails.CoursingOptions.Course",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Course": {
                        "fields": {
                          "courseTokenPair": {
                            "type": "squareup.common.token.TokenPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "straightFire": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "event": {
                            "type": "squareup.bills.Cart.FeatureDetails.CoursingOptions.Course.Event",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "sourceTicketInformation": {
                            "type": "squareup.bills.Cart.FeatureDetails.SourceTicketInformation",
                            "id": 5,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Event": {
                            "fields": {
                              "eventTokenPair": {
                                "type": "squareup.common.token.TokenPair",
                                "id": 1,
                                "rule": "optional"
                              },
                              "eventType": {
                                "type": "squareup.bills.Cart.FeatureDetails.CoursingOptions.Course.Event.EventType",
                                "id": 2,
                                "rule": "optional"
                              },
                              "createdAt": {
                                "type": "squareup.bills.ISO8601Date",
                                "id": 3,
                                "rule": "optional"
                              },
                              "creatorDetails": {
                                "type": "squareup.bills.CreatorDetails",
                                "id": 4,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "EventType": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "CREATION": 1,
                                  "SEND": 2,
                                  "ADDITION": 3,
                                  "FIRE": 4
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "Seating": {
                    "fields": {
                      "seat": {
                        "type": "squareup.bills.Cart.FeatureDetails.Seating.Seat",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "coverCountChangeLog": {
                        "type": "squareup.bills.Cart.FeatureDetails.CoverCountEvent",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "readOnlyCoverCount": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Seat": {
                        "fields": {
                          "seatTokenPair": {
                            "type": "squareup.common.token.TokenPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "enabled": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "createdAt": {
                            "type": "squareup.bills.ISO8601Date",
                            "id": 4,
                            "rule": "optional"
                          },
                          "sourceOpenTicketClientToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "sourceOpenTicketName": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "sourceTicketInformation": {
                            "type": "squareup.bills.Cart.FeatureDetails.SourceTicketInformation",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "BillPrintState": {
                    "fields": {
                      "billPrintedAt": {
                        "type": "squareup.bills.ISO8601Date",
                        "id": 1,
                        "rule": "optional"
                      },
                      "latestBillPrinted": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ReopenDetails": {
                    "fields": {
                      "reopenedAt": {
                        "type": "squareup.bills.ISO8601Date",
                        "id": 1,
                        "rule": "optional"
                      },
                      "tenderDisplayDetails": {
                        "type": "squareup.bills.Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "TenderDisplayDetails": {
                        "fields": {
                          "type": {
                            "type": "squareup.bills.Tender.Type",
                            "id": 1,
                            "rule": "optional"
                          },
                          "totalMoney": {
                            "type": "squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "instrumentDetails": {
                            "type": "squareup.bills.Cart.FeatureDetails.InstrumentDetails.DisplayDetails",
                            "id": 3,
                            "rule": "optional"
                          },
                          "tenderTokenPair": {
                            "type": "squareup.common.token.TokenPair",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "CoverCountEvent": {
                    "fields": {
                      "eventId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "eventType": {
                        "type": "squareup.bills.Cart.FeatureDetails.CoverCountEvent.EventType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "count": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": 0
                        }
                      },
                      "isConfirmed": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "creatorDetails": {
                        "type": "squareup.bills.CreatorDetails",
                        "id": 5,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "squareup.bills.ISO8601Date",
                        "id": 6,
                        "rule": "optional"
                      },
                      "ordinal": {
                        "type": "uint32",
                        "id": 7,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "EventType": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "USER_SELECTED": 1,
                          "SPLIT": 2,
                          "MERGE": 3,
                          "VOID": 4
                        }
                      }
                    }
                  },
                  "AuthAndDelayedCapture": {
                    "fields": {
                      "billServerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "LifecycleEvent": {
                    "fields": {
                      "eventIdPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "eventType": {
                        "type": "squareup.bills.Cart.FeatureDetails.LifecycleEvent.EventType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "squareup.bills.ISO8601Date",
                        "id": 3,
                        "rule": "optional"
                      },
                      "creatorDetails": {
                        "type": "squareup.bills.CreatorDetails",
                        "id": 4,
                        "rule": "optional"
                      },
                      "ownershipTransferDetails": {
                        "type": "squareup.bills.Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "EventType": {
                        "values": {
                          "UNKNOWN": 0,
                          "CLOSE": 1,
                          "REOPEN": 2,
                          "OWNERSHIP_TRANSFER": 3,
                          "OPEN": 4
                        }
                      },
                      "OwnershipTransferDetails": {
                        "fields": {
                          "transferFromEmployee": {
                            "type": "squareup.bills.Employee",
                            "id": 1,
                            "rule": "optional"
                          },
                          "transferToEmployee": {
                            "type": "squareup.bills.Employee",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "PricingEngineState": {
                    "fields": {
                      "blacklistedDiscountIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "blocklistedTaxIds": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "blocklistedSurchargeIds": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "BuyerNotificationDetails": {
                    "fields": {
                      "phoneNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Channel": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": "squareup.bills.Cart.FeatureDetails.Channel.Type",
                        "id": 2,
                        "rule": "optional"
                      },
                      "uid": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "CHANNEL_TYPE_DO_NOT_USE": 0,
                          "MARKETING": 1,
                          "SALES": 2
                        }
                      }
                    }
                  }
                }
              },
              "ReturnType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "LINKED": 1,
                  "UNLINKED": 2
                }
              }
            }
          },
          "Itemization": {
            "fields": {
              "quantity": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "measurementUnit": {
                "type": "squareup.omg.model.Order.QuantityUnit",
                "id": 13,
                "rule": "optional"
              },
              "quantityEntryType": {
                "type": "squareup.bills.Itemization.QuantityEntryType",
                "id": 12,
                "rule": "optional",
                "options": {
                  "default": "MANUALLY_ENTERED"
                }
              },
              "tareQuantity": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              },
              "customNote": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "readOnlyAppliedItemizationGroups": {
                "type": "string",
                "id": 16,
                "rule": "repeated"
              },
              "configuration": {
                "type": "squareup.bills.Itemization.Configuration",
                "id": 4,
                "rule": "optional"
              },
              "writeOnlyBackingDetails": {
                "type": "squareup.bills.Itemization.BackingDetails",
                "id": 5,
                "rule": "optional"
              },
              "readOnlyDisplayDetails": {
                "type": "squareup.bills.Itemization.DisplayDetails",
                "id": 6,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.Itemization.Amounts",
                "id": 7,
                "rule": "optional"
              },
              "itemizationTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 8,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.bills.DatePair",
                "id": 9,
                "rule": "optional"
              },
              "event": {
                "type": "squareup.bills.Itemization.Event",
                "id": 10,
                "rule": "repeated"
              },
              "featureDetails": {
                "type": "squareup.bills.Itemization.FeatureDetails",
                "id": 11,
                "rule": "optional"
              },
              "employeeAttributions": {
                "type": "squareup.bills.Itemization.EmployeeAttribution",
                "id": 14,
                "rule": "repeated"
              },
              "deleted": {
                "type": "bool",
                "id": 100,
                "rule": "optional"
              },
              "waiterExtension": {
                "type": "squareup.waiter.data.WaiterExtension",
                "id": 28250,
                "rule": "optional"
              },
              "deleteReason": {
                "type": "squareup.waiter.private.extensions.DeleteReason",
                "id": 101,
                "rule": "optional"
              },
              "billingData": {
                "type": "squareup.billing.data.BillingItemizationData",
                "id": 100141,
                "rule": "optional"
              }
            },
            "nested": {
              "QuantityEntryType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "MANUALLY_ENTERED": 1,
                  "READ_FROM_SCALE": 2,
                  "MANUAL_WITH_CONNECTED_SCALE": 3,
                  "READ_FROM_SCALE_TARED": 4,
                  "READ_FROM_SCALE_WITH_MANUAL_TARE": 5
                }
              },
              "Configuration": {
                "fields": {
                  "selectedOptions": {
                    "type": "squareup.bills.Itemization.Configuration.SelectedOptions",
                    "id": 1,
                    "rule": "optional"
                  },
                  "backingType": {
                    "type": "squareup.bills.Itemization.Configuration.BackingType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "itemVariationPriceMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "squareup.api.items.MenuCategory",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxCategory": {
                    "type": "squareup.connect.v2.common.TaxCategory",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": "GENERAL_TANGIBLE_GOOD"
                    }
                  }
                },
                "nested": {
                  "SelectedOptions": {
                    "fields": {
                      "itemVariationDeprecated": {
                        "type": "squareup.api.items.ItemVariation",
                        "id": 1,
                        "rule": "optional"
                      },
                      "modifierOption": {
                        "type": "squareup.bills.ModifierOptionLineItem",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "discount": {
                        "type": "squareup.bills.DiscountLineItem",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "fee": {
                        "type": "squareup.bills.FeeLineItem",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "itemVariationDetails": {
                        "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails",
                        "id": 5,
                        "rule": "optional"
                      },
                      "diningOption": {
                        "type": "squareup.bills.DiningOptionLineItem",
                        "id": 6,
                        "rule": "optional"
                      },
                      "surcharge": {
                        "type": "squareup.bills.SurchargeLineItem",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "group": {
                        "type": "squareup.bills.GroupLineItem",
                        "id": 8,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ItemVariationDetails": {
                        "fields": {
                          "readOnlyDisplayDetails": {
                            "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails",
                            "id": 1,
                            "rule": "optional"
                          },
                          "writeOnlyBackingDetails": {
                            "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails",
                            "id": 2,
                            "rule": "optional"
                          },
                          "giftCardDetails": {
                            "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails",
                            "id": 3,
                            "rule": "optional"
                          },
                          "displayVariationName": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "DisplayDetails": {
                            "fields": {
                              "name": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "priceMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "cogsObjectId": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "sku": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "BackingDetails": {
                            "fields": {
                              "itemVariation": {
                                "type": "squareup.api.items.ItemVariation",
                                "id": 1,
                                "rule": "optional"
                              },
                              "merchantCatalogObjects": {
                                "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails.MerchantCatalogObjects",
                                "id": 2,
                                "rule": "optional"
                              },
                              "measurementUnit": {
                                "type": "squareup.omg.model.Order.QuantityUnit",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "MerchantCatalogObjects": {
                                "fields": {
                                  "itemVariation": {
                                    "type": "squareup.items.merchant.CatalogObject",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "GiftCardDetails": {
                            "fields": {
                              "giftCardToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "activityType": {
                                "type": "squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType",
                                "id": 2,
                                "rule": "optional"
                              },
                              "writeOnlyFideliusToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "panSuffix": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "promotionTokens": {
                                "type": "string",
                                "id": 5,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "ActivityType": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "ACTIVATION": 1,
                                  "RELOAD": 2,
                                  "UNACTIVATED_SALE": 3
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "BackingType": {
                    "values": {
                      "UNKNOWN": 0,
                      "CUSTOM_AMOUNT": 1,
                      "ITEMS_SERVICE_ITEM_VARIATION": 2,
                      "CUSTOM_ITEM_VARIATION": 3
                    }
                  }
                }
              },
              "BackingDetails": {
                "fields": {
                  "item": {
                    "type": "squareup.api.items.Item",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemImage": {
                    "type": "squareup.api.items.ItemImage",
                    "id": 2,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "squareup.api.items.MenuCategory",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.Itemization.BackingDetails.MerchantCatalogObjects",
                    "id": 5,
                    "rule": "optional"
                  },
                  "availableOptions": {
                    "type": "squareup.bills.Itemization.BackingDetails.AvailableOptions",
                    "id": 4,
                    "rule": "optional"
                  },
                  "menu": {
                    "type": "squareup.api.items.Menu",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCatalogObjects": {
                    "fields": {
                      "item": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemImage": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 2,
                        "rule": "optional"
                      },
                      "category": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "AvailableOptions": {
                    "fields": {
                      "itemVariation": {
                        "type": "squareup.api.items.ItemVariation",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "modifierList": {
                        "type": "squareup.bills.Itemization.BackingDetails.AvailableOptions.ModifierList",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ModifierList": {
                        "fields": {
                          "modifierList": {
                            "type": "squareup.api.items.ItemModifierList",
                            "id": 1,
                            "rule": "optional"
                          },
                          "modifierOption": {
                            "type": "squareup.api.items.ItemModifierOption",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "DisplayDetails": {
                "fields": {
                  "item": {
                    "type": "squareup.bills.Itemization.DisplayDetails.Item",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Item": {
                    "fields": {
                      "color": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "abbreviation": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "imageUrl": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "cogsObjectId": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "imageId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "menuCategory": {
                        "type": "squareup.bills.Itemization.DisplayDetails.Item.MenuCategory",
                        "id": 8,
                        "rule": "optional"
                      },
                      "menu": {
                        "type": "squareup.bills.Itemization.DisplayDetails.Item.Menu",
                        "id": 9,
                        "rule": "optional"
                      },
                      "kitchenName": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "MenuCategory": {
                        "fields": {
                          "cogsObjectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Menu": {
                        "fields": {
                          "cogsObjectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "Amounts": {
                "fields": {
                  "itemVariationPriceMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemVariationPriceTimesQuantityMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "discountMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "grossSalesMoney": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "readOnlyReportingAmounts": {
                    "type": "squareup.bills.Itemization.Amounts.ReportingAmounts",
                    "id": 7,
                    "rule": "optional"
                  },
                  "taxableAmount": {
                    "type": "squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "surchargeMoney": {
                    "type": "squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "comboPriceAdjustmentMoney": {
                    "type": "squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "comboAppliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "comboAppliedWeight": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ReportingAmounts": {
                    "fields": {
                      "fifoCostOfGoodsSoldAmounts": {
                        "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lifoCostOfGoodsSoldAmounts": {
                        "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts",
                        "id": 2,
                        "rule": "optional"
                      },
                      "averageCostOfGoodsSoldAmounts": {
                        "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts",
                        "id": 3,
                        "rule": "optional"
                      },
                      "fifoVendorCostOfGoodsSoldAmounts": {
                        "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.VendorCostOfGoodsAmounts",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "lifoVendorCostOfGoodsSoldAmounts": {
                        "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.VendorCostOfGoodsAmounts",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "commissionMoney": {
                        "type": "squareup.common.Money",
                        "id": 7,
                        "rule": "optional"
                      },
                      "itemCommissionMoney": {
                        "type": "squareup.common.Money",
                        "id": 8,
                        "rule": "optional"
                      },
                      "serviceCommissionMoney": {
                        "type": "squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      },
                      "tierMin": {
                        "type": "int64",
                        "id": 10,
                        "rule": "optional"
                      },
                      "tierMax": {
                        "type": "int64",
                        "id": 11,
                        "rule": "optional"
                      },
                      "commissionBasisPoints": {
                        "type": "int64",
                        "id": 12,
                        "rule": "optional"
                      },
                      "tierUnit": {
                        "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.TierUnit",
                        "id": 13,
                        "rule": "optional"
                      },
                      "deductedServiceCostMoney": {
                        "type": "squareup.common.Money",
                        "id": 14,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CostOfGoodsAmounts": {
                        "fields": {
                          "itemVariationTotalCostMoney": {
                            "type": "squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemVariationCogsQuantity": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "VendorCostOfGoodsAmounts": {
                        "fields": {
                          "vendorToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "vendorQuantity": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "costOfGoodsSoldAmounts": {
                            "type": "squareup.bills.Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "TierUnit": {
                        "values": {
                          "QUANTITY": 1,
                          "CENTS": 2
                        }
                      }
                    }
                  }
                }
              },
              "Event": {
                "fields": {
                  "eventTokenPair": {
                    "type": "squareup.common.token.TokenPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eventType": {
                    "type": "squareup.bills.Itemization.Event.EventType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.bills.ISO8601Date",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creatorDetails": {
                    "type": "squareup.bills.CreatorDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "splitEventDetails": {
                    "type": "squareup.bills.Itemization.Event.SplitEventDetails",
                    "id": 6,
                    "rule": "optional"
                  },
                  "originalItemization": {
                    "type": "squareup.bills.Itemization.Event.ItemizationReference",
                    "id": 7,
                    "rule": "optional"
                  },
                  "childItemizationTokenPairs": {
                    "type": "squareup.common.token.TokenPair",
                    "id": 8,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "EventType": {
                    "values": {
                      "UNKNOWN": 0,
                      "CREATION": 1,
                      "COMP": 2,
                      "VOID": 3,
                      "UNCOMP": 4,
                      "DELETE": 5,
                      "SPLIT": 6,
                      "FIRE": 7,
                      "SEND": 8,
                      "DISCOUNT": 9,
                      "REMOVE_DISCOUNT": 10,
                      "PRINT": 11,
                      "MOVE": 12,
                      "AMENDED_REOPEN": 13,
                      "REFUNDED_REOPEN": 14,
                      "SPLIT_ITEM_PAYMENT": 15,
                      "UNSPLIT_ITEM_PAYMENT": 16
                    }
                  },
                  "SplitEventDetails": {
                    "fields": {
                      "childItemization": {
                        "type": "squareup.bills.Itemization.Event.SplitEventDetails.ChildItemization",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ChildItemization": {
                        "fields": {
                          "ticketTokenPair": {
                            "type": "squareup.common.token.TokenPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "childItemizationTokenPair": {
                            "type": "squareup.common.token.TokenPair",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "ItemizationReference": {
                    "fields": {
                      "ticketTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemizationTokenPair": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "FeatureDetails": {
                "fields": {
                  "courseTokenPair": {
                    "type": "squareup.common.token.TokenPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "seating": {
                    "type": "squareup.bills.Itemization.FeatureDetails.Seating",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appointmentsServiceDetails": {
                    "type": "squareup.bills.Itemization.FeatureDetails.AppointmentsServiceDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "inheritedItemizationDetails": {
                    "type": "squareup.bills.Itemization.FeatureDetails.InheritedItemizationDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "pricingEngineState": {
                    "type": "squareup.bills.Itemization.FeatureDetails.PricingEngineState",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deviceCredentialToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "signInType": {
                    "type": "squareup.bills.Itemization.FeatureDetails.SignInType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "channels": {
                    "type": "squareup.bills.Cart.FeatureDetails.Channel",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "splitDetails": {
                    "type": "squareup.bills.Itemization.FeatureDetails.LineItemSplitDetails",
                    "id": 9,
                    "rule": "optional"
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Seating": {
                    "fields": {
                      "destination": {
                        "type": "squareup.bills.Itemization.FeatureDetails.Seating.Destination",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Destination": {
                        "fields": {
                          "type": {
                            "type": "squareup.bills.Itemization.FeatureDetails.Seating.Destination.Type",
                            "id": 1,
                            "rule": "optional"
                          },
                          "seatTokenPair": {
                            "type": "squareup.common.token.TokenPair",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "createdAt": {
                            "type": "squareup.bills.ISO8601Date",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "UNKNOWN": 0,
                              "TABLE_SHARE": 1,
                              "SEAT": 2
                            }
                          }
                        }
                      }
                    }
                  },
                  "AppointmentsServiceDetails": {
                    "fields": {
                      "serviceId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "serviceDuration": {
                        "type": "int64",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ordinal": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "transitionTimeDuration": {
                        "type": "int64",
                        "id": 4,
                        "rule": "optional"
                      },
                      "pricingType": {
                        "type": "squareup.api.items.PricingType",
                        "id": 5,
                        "rule": "optional"
                      },
                      "noShowFeeMoney": {
                        "type": "squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "intermissions": {
                        "type": "squareup.api.items.Intermission",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "resourceTokens": {
                        "type": "string",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "resources": {
                        "type": "squareup.bills.Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "anyAvailableEmployee": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ResourceDetails": {
                        "fields": {
                          "resourceToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "InheritedItemizationDetails": {
                    "fields": {
                      "inheritedEventTokenPairs": {
                        "type": "squareup.common.token.TokenPair",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "createReason": {
                        "type": "squareup.bills.Itemization.FeatureDetails.InheritedItemizationDetails.CreateReason",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CreateReason": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "REOPEN": 1
                        }
                      }
                    }
                  },
                  "PricingEngineState": {
                    "fields": {
                      "blacklistedDiscountIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "blocklistedTaxIds": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "SignInType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "DEVICE_CODE": 1,
                      "USERNAME_PASSWORD": 2
                    }
                  },
                  "LineItemSplitDetails": {
                    "fields": {
                      "splitId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "splitPartNumber": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "splitTotalParts": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "originalLineItemPricing": {
                        "type": "squareup.bills.Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "LineItemPricing": {
                        "fields": {
                          "basePriceMoney": {
                            "type": "squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "grossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "originalQuantity": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "originalModifierBasePrices": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "keyType": "string"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "EmployeeAttribution": {
                "fields": {
                  "employee": {
                    "type": "squareup.bills.Employee",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "DiscountLineItem": {
            "fields": {
              "configuration": {
                "type": "squareup.bills.DiscountLineItem.Configuration",
                "id": 5,
                "rule": "optional"
              },
              "writeOnlyBackingDetails": {
                "type": "squareup.bills.DiscountLineItem.BackingDetails",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyDisplayDetails": {
                "type": "squareup.bills.DiscountLineItem.DisplayDetails",
                "id": 2,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.DiscountLineItem.Amounts",
                "id": 3,
                "rule": "optional"
              },
              "discountLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 4,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.bills.DatePair",
                "id": 6,
                "rule": "optional"
              },
              "applicationScope": {
                "type": "squareup.bills.ApplicationScope",
                "id": 7,
                "rule": "optional"
              },
              "applicationMethod": {
                "type": "squareup.bills.DiscountLineItem.ApplicationMethod",
                "id": 8,
                "rule": "optional"
              },
              "discountQuantity": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "deleted": {
                "type": "bool",
                "id": 100,
                "rule": "optional"
              },
              "waiterExtension": {
                "type": "squareup.waiter.data.WaiterExtension",
                "id": 28250,
                "rule": "optional"
              },
              "deleteReason": {
                "type": "squareup.waiter.private.extensions.DeleteReason",
                "id": 101,
                "rule": "optional"
              }
            },
            "nested": {
              "Configuration": {
                "fields": {
                  "variablePercentage": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "variableAmountMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BackingDetails": {
                "fields": {
                  "discount": {
                    "type": "squareup.api.items.Discount",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.DiscountLineItem.BackingDetails.MerchantCatalogObjects",
                    "id": 4,
                    "rule": "optional"
                  },
                  "couponToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "backingType": {
                    "type": "squareup.bills.DiscountLineItem.BackingDetails.BackingType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "couponTokens": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "rewardTokens": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "MerchantCatalogObjects": {
                    "fields": {
                      "discount": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BackingType": {
                    "values": {
                      "ITEMS_SERVICE_DISCOUNT": 0,
                      "CUSTOM_DISCOUNT": 1
                    }
                  }
                }
              },
              "DisplayDetails": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cogsObjectId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "couponToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "applicationMethod": {
                    "type": "squareup.api.items.Discount.ApplicationMethod",
                    "id": 5,
                    "rule": "optional"
                  },
                  "couponTokens": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "Amounts": {
                "fields": {
                  "appliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ApplicationMethod": {
                "values": {
                  "UNKNOWN": 0,
                  "MANUAL": 1,
                  "PRICING_RULE": 2
                }
              }
            }
          },
          "ApplicationScope": {
            "values": {
              "UNKNOWN": 0,
              "ITEMIZATION_LEVEL": 1,
              "CART_LEVEL": 2,
              "CART_LEVEL_FIXED": 3,
              "ITEMIZATION_LEVEL_PER_QUANTITY": 4
            }
          },
          "FeeLineItem": {
            "fields": {
              "writeOnlyBackingDetails": {
                "type": "squareup.bills.FeeLineItem.BackingDetails",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyDisplayDetails": {
                "type": "squareup.bills.FeeLineItem.DisplayDetails",
                "id": 2,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.FeeLineItem.Amounts",
                "id": 3,
                "rule": "optional"
              },
              "readOnlyTranslatedName": {
                "type": "squareup.bills.TranslatedName",
                "id": 4,
                "rule": "optional"
              },
              "feeLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 5,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.bills.DatePair",
                "id": 6,
                "rule": "optional"
              },
              "applicationScope": {
                "type": "squareup.bills.ApplicationScope",
                "id": 7,
                "rule": "optional"
              },
              "applicationMethod": {
                "type": "squareup.bills.FeeLineItem.ApplicationMethod",
                "id": 8,
                "rule": "optional"
              },
              "deleted": {
                "type": "bool",
                "id": 100,
                "rule": "optional"
              },
              "waiterExtension": {
                "type": "squareup.waiter.data.WaiterExtension",
                "id": 28250,
                "rule": "optional"
              },
              "deleteReason": {
                "type": "squareup.waiter.private.extensions.DeleteReason",
                "id": 101,
                "rule": "optional"
              }
            },
            "nested": {
              "BackingDetails": {
                "fields": {
                  "fee": {
                    "type": "squareup.api.items.Fee",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.FeeLineItem.BackingDetails.MerchantCatalogObjects",
                    "id": 3,
                    "rule": "optional"
                  },
                  "backingType": {
                    "type": "squareup.bills.FeeLineItem.BackingDetails.BackingType",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCatalogObjects": {
                    "fields": {
                      "fee": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BackingType": {
                    "values": {
                      "ITEMS_SERVICE_FEE": 0,
                      "CUSTOM_FEE": 1
                    }
                  }
                }
              },
              "DisplayDetails": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "calculationPhase": {
                    "type": "squareup.api.items.CalculationPhase",
                    "id": 3,
                    "rule": "optional"
                  },
                  "inclusionType": {
                    "type": "squareup.api.items.Fee.InclusionType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxTypeName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "taxTypeNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "taxTypeId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cogsObjectId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "taxLabelOrder": {
                    "type": "int32",
                    "id": 9,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": "squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "Amounts": {
                "fields": {
                  "appliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appliedToMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "afterApplicationTotalMoney": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ApplicationMethod": {
                "values": {
                  "UNKNOWN": 0,
                  "MANUAL": 1,
                  "AUTOMATIC": 2
                }
              }
            }
          },
          "ModifierOptionLineItem": {
            "fields": {
              "amounts": {
                "type": "squareup.bills.ModifierOptionLineItem.Amounts",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyDisplayDetails": {
                "type": "squareup.bills.ModifierOptionLineItem.DisplayDetails",
                "id": 2,
                "rule": "optional"
              },
              "writeOnlyBackingDetails": {
                "type": "squareup.bills.ModifierOptionLineItem.BackingDetails",
                "id": 3,
                "rule": "optional"
              },
              "modifierOptionLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 4,
                "rule": "optional"
              },
              "hideFromCustomer": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "featureDetails": {
                "type": "squareup.bills.ModifierOptionLineItem.FeatureDetails",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "Amounts": {
                "fields": {
                  "modifierOptionMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modifierOptionTimesQuantityMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DisplayDetails": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cogsObjectId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "modifierList": {
                    "type": "squareup.bills.ModifierOptionLineItem.DisplayDetails.ModifierList",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ModifierList": {
                    "fields": {
                      "cogsObjectId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "selectionType": {
                        "type": "squareup.api.items.ItemModifierList.SelectionType",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "BackingDetails": {
                "fields": {
                  "backingModifierOption": {
                    "type": "squareup.api.items.ItemModifierOption",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modifierList": {
                    "type": "squareup.api.items.ItemModifierList",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.ModifierOptionLineItem.BackingDetails.MerchantCatalogObjects",
                    "id": 4,
                    "rule": "optional"
                  },
                  "backingType": {
                    "type": "squareup.bills.ModifierOptionLineItem.BackingDetails.BackingType",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCatalogObjects": {
                    "fields": {
                      "modifierOption": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      },
                      "modifierList": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BackingType": {
                    "values": {
                      "UNKNOWN": 0,
                      "ITEMS_SERVICE_MODIFIER_OPTION": 1,
                      "CUSTOM_MODIFIER_OPTION": 2
                    }
                  }
                }
              },
              "FeatureDetails": {
                "fields": {
                  "conversationalMode": {
                    "type": "squareup.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "quantities": {
                    "type": "squareup.bills.ModifierOptionLineItem.FeatureDetails.Quantities",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ConversationalMode": {
                    "fields": {
                      "type": {
                        "type": "squareup.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "uid": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "UNKNOWN": 0,
                          "ADD": 1,
                          "EXTRA": 2,
                          "SIDE": 3,
                          "SUB": 4,
                          "NO": 5,
                          "ALLERGY": 6
                        }
                      }
                    }
                  },
                  "Quantities": {
                    "fields": {
                      "modifierQuantity": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "modifierQuantityTimesItemizationQuantity": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          },
          "RoundingAdjustmentLineItem": {
            "fields": {
              "calculationPhase": {
                "type": "squareup.api.items.CalculationPhase",
                "id": 1,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.RoundingAdjustmentLineItem.Amounts",
                "id": 2,
                "rule": "optional"
              },
              "roundingAdjustmentLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 3,
                "rule": "optional"
              },
              "localizedName": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "Amounts": {
                "fields": {
                  "appliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "DiningOptionLineItem": {
            "fields": {
              "diningOptionLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "backingDetails": {
                "type": "squareup.bills.DiningOptionLineItem.BackingDetails",
                "id": 2,
                "rule": "optional"
              },
              "applicationScope": {
                "type": "squareup.bills.ApplicationScope",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "BackingDetails": {
                "fields": {
                  "diningOption": {
                    "type": "squareup.api.items.DiningOption",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.DiningOptionLineItem.BackingDetails.MerchantCatalogObjects",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCatalogObjects": {
                    "fields": {
                      "diningOption": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          },
          "TipLineItem": {
            "fields": {
              "tipLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.TipLineItem.Amounts",
                "id": 2,
                "rule": "optional"
              },
              "tenderServerToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "Amounts": {
                "fields": {
                  "appliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "SurchargeLineItem": {
            "fields": {
              "surchargeLineItemIdPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "backingDetails": {
                "type": "squareup.bills.SurchargeLineItem.BackingDetails",
                "id": 2,
                "rule": "optional"
              },
              "amounts": {
                "type": "squareup.bills.SurchargeLineItem.Amounts",
                "id": 3,
                "rule": "optional"
              },
              "writeOnlyDeleted": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "fee": {
                "type": "squareup.bills.FeeLineItem",
                "id": 5,
                "rule": "repeated"
              },
              "pricingEngineState": {
                "type": "squareup.bills.SurchargeLineItem.PricingEngineState",
                "id": 6,
                "rule": "optional"
              },
              "quantity": {
                "type": "string",
                "id": 7,
                "rule": "optional",
                "options": {
                  "default": "1.0"
                }
              },
              "createdAt": {
                "type": "squareup.bills.DatePair",
                "id": 8,
                "rule": "optional"
              },
              "applicationScope": {
                "type": "squareup.bills.ApplicationScope",
                "id": 9,
                "rule": "optional"
              },
              "applicationMethod": {
                "type": "squareup.bills.SurchargeLineItem.ApplicationMethod",
                "id": 10,
                "rule": "optional"
              },
              "taxCategory": {
                "type": "squareup.connect.v2.common.TaxCategory",
                "id": 11,
                "rule": "optional"
              },
              "disabled": {
                "type": "bool",
                "id": 12,
                "rule": "optional"
              },
              "topLevelSurchargeLineItemIdPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 13,
                "rule": "optional"
              }
            },
            "nested": {
              "BackingDetails": {
                "fields": {
                  "surcharge": {
                    "type": "squareup.api.items.Surcharge",
                    "id": 1,
                    "rule": "optional"
                  },
                  "backingType": {
                    "type": "squareup.bills.SurchargeLineItem.BackingDetails.BackingType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.SurchargeLineItem.BackingDetails.MerchantCatalogObjects",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BackingType": {
                    "values": {
                      "ITEMS_SERVICE_SURCHARGE": 0,
                      "CUSTOM_SURCHARGE": 1
                    }
                  },
                  "MerchantCatalogObjects": {
                    "fields": {
                      "surcharge": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "Amounts": {
                "fields": {
                  "appliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "PricingEngineState": {
                "fields": {
                  "blocklistedTaxIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ApplicationMethod": {
                "values": {
                  "UNKNOWN": 0,
                  "MANUAL": 1,
                  "PRICING_RULE": 2
                }
              }
            }
          },
          "GroupLineItem": {
            "fields": {
              "type": {
                "type": "squareup.bills.ItemizationGroup.Type",
                "id": 1,
                "rule": "optional"
              },
              "groupClientToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "configuration": {
                "type": "squareup.bills.GroupLineItem.Configuration",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Configuration": {
                "fields": {
                  "comboConfiguration": {
                    "type": "squareup.bills.GroupLineItem.Configuration.ComboConfiguration",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ComboConfiguration": {
                    "fields": {
                      "appliedComboClientToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "appliedComboChoiceId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          },
          "ItemizationGroup": {
            "fields": {
              "itemizationGroupTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "itemizationClientTokens": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "type": {
                "type": "squareup.bills.ItemizationGroup.Type",
                "id": 3,
                "rule": "optional"
              },
              "writeOnlyBackingDetails": {
                "type": "squareup.bills.ItemizationGroup.BackingDetails",
                "id": 4,
                "rule": "optional"
              },
              "readOnlyDisplayDetails": {
                "type": "squareup.bills.ItemizationGroup.DisplayDetails",
                "id": 5,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "DEFAULT_ITEMIZATION_GROUP_TYPE_DO_NOT_USE": 0,
                  "CUSTOM": 1,
                  "COMBO": 2
                }
              },
              "BackingDetails": {
                "fields": {
                  "item": {
                    "type": "squareup.api.items.Item",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemVariation": {
                    "type": "squareup.api.items.ItemVariation",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantCatalogObjects": {
                    "type": "squareup.bills.ItemizationGroup.BackingDetails.MerchantCatalogObjects",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MerchantCatalogObjects": {
                    "fields": {
                      "itemCatalogObject": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemVariationCatalogObject": {
                        "type": "squareup.items.merchant.CatalogObject",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "DisplayDetails": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "variationName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "note": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "comboChoices": {
                    "type": "squareup.bills.ItemizationGroup.DisplayDetails.ComboChoice",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "itemVariationPriceMoney": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ComboChoice": {
                    "fields": {
                      "comboChoiceId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "clientToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "validationDetails": {
                        "type": "squareup.bills.ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ValidationDetails": {
                        "fields": {
                          "item": {
                            "type": "squareup.api.items.Item",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemVariation": {
                            "type": "squareup.api.items.ItemVariation",
                            "id": 2,
                            "rule": "optional"
                          },
                          "category": {
                            "type": "squareup.api.items.MenuCategory",
                            "id": 3,
                            "rule": "optional"
                          },
                          "numSelections": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          "ReturnTipLineItem": {
            "fields": {
              "sourceTipLineItemTokenPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "tipLineItem": {
                "type": "squareup.bills.TipLineItem",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ReturnSurchargeLineItem": {
            "fields": {
              "sourceSurchargeLineItemIdPair": {
                "type": "squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "surchargeLineItem": {
                "type": "squareup.bills.SurchargeLineItem",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bills?.nested?.Cart && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.CatalogVersion && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.LineItems && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.ReturnLineItems && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.ReturnLineItems?.nested?.ReturnItemization && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.AmountDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.PickupOrder && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.PredefinedTicket && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.OpenTicketProductAssociation && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.CreatedDeviceInfo && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.ReservationInformation && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.ReservationInformation?.nested?.ReservationNotes && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.ReservationInformation?.nested?.Deposit && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Invoice && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Invoice?.nested?.AssociatedOrder && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.KitchenPrinting && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.InstrumentDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.InstrumentDetails?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BuyerInfo && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BuyerInfo?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.AppointmentsDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Order && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.SourceTicketInformation && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions?.nested?.Course && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions?.nested?.Course?.nested?.Event && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions?.nested?.Course?.nested?.Event?.nested?.EventType && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Seating && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Seating?.nested?.Seat && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BillPrintState && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.ReopenDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.ReopenDetails?.nested?.TenderDisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoverCountEvent && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoverCountEvent?.nested?.EventType && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.AuthAndDelayedCapture && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.LifecycleEvent && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.LifecycleEvent?.nested?.EventType && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.LifecycleEvent?.nested?.OwnershipTransferDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.PricingEngineState && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BuyerNotificationDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Channel && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Channel?.nested?.Type && !$root.nested?.squareup?.nested?.bills?.nested?.Cart?.nested?.ReturnType && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.QuantityEntryType && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.GiftCardDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.GiftCardDetails?.nested?.ActivityType && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.BackingType && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails?.nested?.AvailableOptions && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails?.nested?.AvailableOptions?.nested?.ModifierList && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails?.nested?.Item && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails?.nested?.Item?.nested?.MenuCategory && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails?.nested?.Item?.nested?.Menu && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Amounts?.nested?.ReportingAmounts && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.CostOfGoodsAmounts && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.VendorCostOfGoodsAmounts && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.TierUnit && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Event && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.EventType && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.SplitEventDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.SplitEventDetails?.nested?.ChildItemization && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.ItemizationReference && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.Seating && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.Seating?.nested?.Destination && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.Seating?.nested?.Destination?.nested?.Type && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.AppointmentsServiceDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.AppointmentsServiceDetails?.nested?.ResourceDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.InheritedItemizationDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.InheritedItemizationDetails?.nested?.CreateReason && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.PricingEngineState && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.SignInType && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.LineItemSplitDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.LineItemSplitDetails?.nested?.LineItemPricing && !$root.nested?.squareup?.nested?.bills?.nested?.Itemization?.nested?.EmployeeAttribution && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.Configuration && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.DiscountLineItem?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.bills?.nested?.ApplicationScope && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.FeeLineItem?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.DisplayDetails?.nested?.ModifierList && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails?.nested?.ConversationalMode && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails?.nested?.ConversationalMode?.nested?.Type && !$root.nested?.squareup?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails?.nested?.Quantities && !$root.nested?.squareup?.nested?.bills?.nested?.RoundingAdjustmentLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.RoundingAdjustmentLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.DiningOptionLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.DiningOptionLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.DiningOptionLineItem?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.TipLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.TipLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem?.nested?.PricingEngineState && !$root.nested?.squareup?.nested?.bills?.nested?.SurchargeLineItem?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.bills?.nested?.GroupLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.GroupLineItem?.nested?.Configuration && !$root.nested?.squareup?.nested?.bills?.nested?.GroupLineItem?.nested?.Configuration?.nested?.ComboConfiguration && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup?.nested?.Type && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup?.nested?.DisplayDetails?.nested?.ComboChoice && !$root.nested?.squareup?.nested?.bills?.nested?.ItemizationGroup?.nested?.DisplayDetails?.nested?.ComboChoice?.nested?.ValidationDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ReturnTipLineItem && !$root.nested?.squareup?.nested?.bills?.nested?.ReturnSurchargeLineItem) {
  $root.addJSON(jsonData);
}

/**
 * Container for all line items on a bill.
 *
 * The cart should contain all information necessary to provide accurate reporting.
 * NEXT TAG: 10
 *
 * SOURCE Cart @ squareup/bills/cart.proto at 29:1
 */
export const Cart = $root.lookupType('squareup.bills.Cart');
fixType(Cart);
Builder.createAndAttachToType(Cart);
/**
 * Specific version of the catalog objects used in this cart.
 *
 * SOURCE CatalogVersion @ squareup/bills/cart.proto at 32:3
 */
Cart.CatalogVersion = $root.lookupEnum('squareup.bills.Cart.CatalogVersion').values;
/**
 * Items sold by this bill.
 *
 * SOURCE LineItems @ squareup/bills/cart.proto at 42:3
 */
Cart.LineItems = $root.lookupType('squareup.bills.Cart.LineItems');
fixType(Cart.LineItems);
Builder.createAndAttachToType(Cart.LineItems);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 96:3
 */
Cart.Amounts = $root.lookupType('squareup.bills.Cart.Amounts');
fixType(Cart.Amounts);
Builder.createAndAttachToType(Cart.Amounts);
/**
 * SOURCE ReturnLineItems @ squareup/bills/cart.proto at 132:3
 */
Cart.ReturnLineItems = $root.lookupType('squareup.bills.Cart.ReturnLineItems');
fixType(Cart.ReturnLineItems);
Builder.createAndAttachToType(Cart.ReturnLineItems);
/**
 * SOURCE ReturnItemization @ squareup/bills/cart.proto at 136:5
 */
Cart.ReturnLineItems.ReturnItemization = $root.lookupType('squareup.bills.Cart.ReturnLineItems.ReturnItemization');
fixType(Cart.ReturnLineItems.ReturnItemization);
Builder.createAndAttachToType(Cart.ReturnLineItems.ReturnItemization);
/**
 * The total return amount in the bill.
 *
 * SOURCE AmountDetails @ squareup/bills/cart.proto at 161:3
 */
Cart.AmountDetails = $root.lookupType('squareup.bills.Cart.AmountDetails');
fixType(Cart.AmountDetails);
Builder.createAndAttachToType(Cart.AmountDetails);
/**
 * SOURCE FeatureDetails @ squareup/bills/cart.proto at 184:3
 */
Cart.FeatureDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails');
fixType(Cart.FeatureDetails);
Builder.createAndAttachToType(Cart.FeatureDetails);
/**
 * SOURCE PickupOrder @ squareup/bills/cart.proto at 193:5
 */
Cart.FeatureDetails.PickupOrder = $root.lookupType('squareup.bills.Cart.FeatureDetails.PickupOrder');
fixType(Cart.FeatureDetails.PickupOrder);
Builder.createAndAttachToType(Cart.FeatureDetails.PickupOrder);
/**
 * SOURCE OpenTicket @ squareup/bills/cart.proto at 202:5
 */
Cart.FeatureDetails.OpenTicket = $root.lookupType('squareup.bills.Cart.FeatureDetails.OpenTicket');
fixType(Cart.FeatureDetails.OpenTicket);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket);
/**
 * The predefined ticket details associated with this open ticket.
 *
 * Merchants can create predefined ticket groups and ticket templates to implement a rudimentary form of table management.
 * A ticket group has many ticket templates.  Ticket groups would be something like "Bar" or "Patio", while ticket templates
 * would be something like "Table 1", "Bar 2", etc.
 *
 * Even with predefined tickets enabled, merchants can create "custom" tickets that do not have a ticket template.  These custom
 * tickets can still have a ticket group.  Think of a custom ticket named "Guy In Red Shirt" assigned to the ticket group "Bar"
 * (because he left his credit card at the bar).
 *
 * SOURCE PredefinedTicket @ squareup/bills/cart.proto at 234:7
 */
Cart.FeatureDetails.OpenTicket.PredefinedTicket = $root.lookupType('squareup.bills.Cart.FeatureDetails.OpenTicket.PredefinedTicket');
fixType(Cart.FeatureDetails.OpenTicket.PredefinedTicket);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.PredefinedTicket);
/**
 * Product-specific open ticket-level associations.
 *
 * SOURCE OpenTicketProductAssociation @ squareup/bills/cart.proto at 252:7
 */
Cart.FeatureDetails.OpenTicket.OpenTicketProductAssociation = $root.lookupEnum('squareup.bills.Cart.FeatureDetails.OpenTicket.OpenTicketProductAssociation').values;
/**
 * Information about the device that created this OpenTicket.
 *
 * SOURCE CreatedDeviceInfo @ squareup/bills/cart.proto at 273:7
 */
Cart.FeatureDetails.OpenTicket.CreatedDeviceInfo = $root.lookupType('squareup.bills.Cart.FeatureDetails.OpenTicket.CreatedDeviceInfo');
fixType(Cart.FeatureDetails.OpenTicket.CreatedDeviceInfo);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.CreatedDeviceInfo);
/**
 * Contains details on the reservation the OpenTicket is tied to. This is only intended to be used for Restaurants Reservations.
 *
 * SOURCE ReservationInformation @ squareup/bills/cart.proto at 302:7
 */
Cart.FeatureDetails.OpenTicket.ReservationInformation = $root.lookupType('squareup.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation');
fixType(Cart.FeatureDetails.OpenTicket.ReservationInformation);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.ReservationInformation);
/**
 * SOURCE ReservationNotes @ squareup/bills/cart.proto at 327:9
 */
Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes = $root.lookupType('squareup.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes');
fixType(Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes);
/**
 * SOURCE Deposit @ squareup/bills/cart.proto at 362:9
 */
Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit = $root.lookupType('squareup.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit');
fixType(Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit, {
  depositAmount: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit);
/**
 * SOURCE Invoice @ squareup/bills/cart.proto at 388:5
 */
Cart.FeatureDetails.Invoice = $root.lookupType('squareup.bills.Cart.FeatureDetails.Invoice');
fixType(Cart.FeatureDetails.Invoice);
Builder.createAndAttachToType(Cart.FeatureDetails.Invoice);
/**
 * Contains the identifier and version of an order if there is one associated with the invoice.
 *
 * SOURCE AssociatedOrder @ squareup/bills/cart.proto at 403:7
 */
Cart.FeatureDetails.Invoice.AssociatedOrder = $root.lookupType('squareup.bills.Cart.FeatureDetails.Invoice.AssociatedOrder');
fixType(Cart.FeatureDetails.Invoice.AssociatedOrder);
Builder.createAndAttachToType(Cart.FeatureDetails.Invoice.AssociatedOrder);
/**
 * SOURCE KitchenPrinting @ squareup/bills/cart.proto at 413:5
 */
Cart.FeatureDetails.KitchenPrinting = $root.lookupType('squareup.bills.Cart.FeatureDetails.KitchenPrinting');
fixType(Cart.FeatureDetails.KitchenPrinting);
Builder.createAndAttachToType(Cart.FeatureDetails.KitchenPrinting);
/**
 * Additional details if the sale has a card on file attached, currently this is used only when a customer added.
 *
 * SOURCE InstrumentDetails @ squareup/bills/cart.proto at 422:5
 */
Cart.FeatureDetails.InstrumentDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.InstrumentDetails');
fixType(Cart.FeatureDetails.InstrumentDetails, {
  instrumentToken: {
    required: true,
    notEmpty: true
  },
  displayDetails: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.InstrumentDetails);
/**
 * Denormalized instrument data for better client performance.
 *
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 429:7
 */
Cart.FeatureDetails.InstrumentDetails.DisplayDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.InstrumentDetails.DisplayDetails');
fixType(Cart.FeatureDetails.InstrumentDetails.DisplayDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.InstrumentDetails.DisplayDetails);
/**
 * SOURCE BuyerInfo @ squareup/bills/cart.proto at 439:5
 */
Cart.FeatureDetails.BuyerInfo = $root.lookupType('squareup.bills.Cart.FeatureDetails.BuyerInfo');
fixType(Cart.FeatureDetails.BuyerInfo);
Builder.createAndAttachToType(Cart.FeatureDetails.BuyerInfo);
/**
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 446:7
 */
Cart.FeatureDetails.BuyerInfo.DisplayDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.BuyerInfo.DisplayDetails');
fixType(Cart.FeatureDetails.BuyerInfo.DisplayDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.BuyerInfo.DisplayDetails);
/**
 * SOURCE AppointmentsDetails @ squareup/bills/cart.proto at 493:5
 */
Cart.FeatureDetails.AppointmentsDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.AppointmentsDetails');
fixType(Cart.FeatureDetails.AppointmentsDetails, {
  appointmentId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.AppointmentsDetails);
/**
 * Details for a shared order model object (go/shared-order-model), not the
 * Square pickup order.
 *
 * SOURCE Order @ squareup/bills/cart.proto at 516:5
 */
Cart.FeatureDetails.Order = $root.lookupType('squareup.bills.Cart.FeatureDetails.Order');
fixType(Cart.FeatureDetails.Order);
Builder.createAndAttachToType(Cart.FeatureDetails.Order);
/**
 * Ticket information used to track information about feature details such as
 * coursing and seating when tickets are split & merged.
 *
 * SOURCE SourceTicketInformation @ squareup/bills/cart.proto at 539:5
 */
Cart.FeatureDetails.SourceTicketInformation = $root.lookupType('squareup.bills.Cart.FeatureDetails.SourceTicketInformation');
fixType(Cart.FeatureDetails.SourceTicketInformation, {
  clientId: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.SourceTicketInformation);
/**
 * SOURCE CoursingOptions @ squareup/bills/cart.proto at 544:5
 */
Cart.FeatureDetails.CoursingOptions = $root.lookupType('squareup.bills.Cart.FeatureDetails.CoursingOptions');
fixType(Cart.FeatureDetails.CoursingOptions);
Builder.createAndAttachToType(Cart.FeatureDetails.CoursingOptions);
/**
 * SOURCE Course @ squareup/bills/cart.proto at 545:7
 */
Cart.FeatureDetails.CoursingOptions.Course = $root.lookupType('squareup.bills.Cart.FeatureDetails.CoursingOptions.Course');
fixType(Cart.FeatureDetails.CoursingOptions.Course, {
  courseTokenPair: {
    required: true
  },
  straightFire: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.CoursingOptions.Course);
/**
 * SOURCE Event @ squareup/bills/cart.proto at 563:9
 */
Cart.FeatureDetails.CoursingOptions.Course.Event = $root.lookupType('squareup.bills.Cart.FeatureDetails.CoursingOptions.Course.Event');
fixType(Cart.FeatureDetails.CoursingOptions.Course.Event, {
  eventTokenPair: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.CoursingOptions.Course.Event);
/**
 * SOURCE EventType @ squareup/bills/cart.proto at 564:11
 */
Cart.FeatureDetails.CoursingOptions.Course.Event.EventType = $root.lookupEnum('squareup.bills.Cart.FeatureDetails.CoursingOptions.Course.Event.EventType').values;
/**
 * SOURCE Seating @ squareup/bills/cart.proto at 630:5
 */
Cart.FeatureDetails.Seating = $root.lookupType('squareup.bills.Cart.FeatureDetails.Seating');
fixType(Cart.FeatureDetails.Seating);
Builder.createAndAttachToType(Cart.FeatureDetails.Seating);
/**
 * SOURCE Seat @ squareup/bills/cart.proto at 631:7
 */
Cart.FeatureDetails.Seating.Seat = $root.lookupType('squareup.bills.Cart.FeatureDetails.Seating.Seat');
fixType(Cart.FeatureDetails.Seating.Seat, {
  seatTokenPair: {
    required: true
  },
  ordinal: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.Seating.Seat);
/**
 * Maintains information about whether the entire state of the open ticket has been printed as a bill.
 * Refers specifically to the latest recorded printed bill.
 *
 * Based on https://docs.google.com/document/d/115dO-1al2zSpQVoW7SjVfDjQBMd1X_Dd-eR1e94gViM/edit#
 *
 * SOURCE BillPrintState @ squareup/bills/cart.proto at 677:5
 */
Cart.FeatureDetails.BillPrintState = $root.lookupType('squareup.bills.Cart.FeatureDetails.BillPrintState');
fixType(Cart.FeatureDetails.BillPrintState);
Builder.createAndAttachToType(Cart.FeatureDetails.BillPrintState);
/**
 * Contains display details for carts representing re-opened tickets.
 *
 * SOURCE ReopenDetails @ squareup/bills/cart.proto at 690:5
 */
Cart.FeatureDetails.ReopenDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.ReopenDetails');
fixType(Cart.FeatureDetails.ReopenDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.ReopenDetails);
/**
 * Per-tender display details--type, total money, and instrument info.
 *
 * SOURCE TenderDisplayDetails @ squareup/bills/cart.proto at 695:7
 */
Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails');
fixType(Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails);
/**
 * Contains details about how a cover count is changed on a RST open ticket during its lifecycle.
 *
 * SOURCE CoverCountEvent @ squareup/bills/cart.proto at 717:5
 */
Cart.FeatureDetails.CoverCountEvent = $root.lookupType('squareup.bills.Cart.FeatureDetails.CoverCountEvent');
fixType(Cart.FeatureDetails.CoverCountEvent, {
  eventId: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.CoverCountEvent);
/**
 * SOURCE EventType @ squareup/bills/cart.proto at 718:7
 */
Cart.FeatureDetails.CoverCountEvent.EventType = $root.lookupEnum('squareup.bills.Cart.FeatureDetails.CoverCountEvent.EventType').values;
/**
 * Contains reference to the payment device containing the pre-authed card for the new feature Auth and Delayed Capture (i.e opening a bar tab).
 *
 * SOURCE AuthAndDelayedCapture @ squareup/bills/cart.proto at 762:5
 */
Cart.FeatureDetails.AuthAndDelayedCapture = $root.lookupType('squareup.bills.Cart.FeatureDetails.AuthAndDelayedCapture');
fixType(Cart.FeatureDetails.AuthAndDelayedCapture);
Builder.createAndAttachToType(Cart.FeatureDetails.AuthAndDelayedCapture);
/**
 * SOURCE LifecycleEvent @ squareup/bills/cart.proto at 770:5
 */
Cart.FeatureDetails.LifecycleEvent = $root.lookupType('squareup.bills.Cart.FeatureDetails.LifecycleEvent');
fixType(Cart.FeatureDetails.LifecycleEvent, {
  eventIdPair: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.LifecycleEvent);
/**
 * SOURCE EventType @ squareup/bills/cart.proto at 773:7
 */
Cart.FeatureDetails.LifecycleEvent.EventType = $root.lookupEnum('squareup.bills.Cart.FeatureDetails.LifecycleEvent.EventType').values;
/**
 * SOURCE OwnershipTransferDetails @ squareup/bills/cart.proto at 810:7
 */
Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails');
fixType(Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails, {
  transferToEmployee: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails);
/**
 * Pricing engine state tied to a cart.
 *
 * SOURCE PricingEngineState @ squareup/bills/cart.proto at 833:5
 */
Cart.FeatureDetails.PricingEngineState = $root.lookupType('squareup.bills.Cart.FeatureDetails.PricingEngineState');
fixType(Cart.FeatureDetails.PricingEngineState);
Builder.createAndAttachToType(Cart.FeatureDetails.PricingEngineState);
/**
 * Pickup details for this sale.
 *
 * SOURCE BuyerNotificationDetails @ squareup/bills/cart.proto at 858:5
 */
Cart.FeatureDetails.BuyerNotificationDetails = $root.lookupType('squareup.bills.Cart.FeatureDetails.BuyerNotificationDetails');
fixType(Cart.FeatureDetails.BuyerNotificationDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.BuyerNotificationDetails);
/**
 * Channels for the bill
 *
 * SOURCE Channel @ squareup/bills/cart.proto at 872:5
 */
Cart.FeatureDetails.Channel = $root.lookupType('squareup.bills.Cart.FeatureDetails.Channel');
fixType(Cart.FeatureDetails.Channel);
Builder.createAndAttachToType(Cart.FeatureDetails.Channel);
/**
 * SOURCE Type @ squareup/bills/cart.proto at 885:7
 */
Cart.FeatureDetails.Channel.Type = $root.lookupEnum('squareup.bills.Cart.FeatureDetails.Channel.Type').values;
/**
 * Demarcates a return as either Linked or Unlinked
 *
 * SOURCE ReturnType @ squareup/bills/cart.proto at 924:4
 */
Cart.ReturnType = $root.lookupEnum('squareup.bills.Cart.ReturnType').values;
/**
 * Individual itemization on the bill.
 * This is an item and associated taxes, discounts, etc.
 *
 * Example: If there is $1 total tax two items, each itemization will have $0.50 tax.
 * The latter will be reflected in this individual itemization. Other calculations are more complex.
 *
 * For calculation details and rounding rules, refer to: https://go.sqprod.co/itemizations
 *
 * SOURCE Itemization @ squareup/bills/cart.proto at 949:1
 */
export const Itemization = $root.lookupType('squareup.bills.Itemization');
fixType(Itemization);
Builder.createAndAttachToType(Itemization);
/**
 * How the quantity was added to the itemization
 *
 * SOURCE QuantityEntryType @ squareup/bills/cart.proto at 985:3
 */
Itemization.QuantityEntryType = $root.lookupEnum('squareup.bills.Itemization.QuantityEntryType').values;
/**
 * SOURCE Configuration @ squareup/bills/cart.proto at 1011:3
 */
Itemization.Configuration = $root.lookupType('squareup.bills.Itemization.Configuration');
fixType(Itemization.Configuration);
Builder.createAndAttachToType(Itemization.Configuration);
/**
 * SOURCE SelectedOptions @ squareup/bills/cart.proto at 1012:5
 */
Itemization.Configuration.SelectedOptions = $root.lookupType('squareup.bills.Itemization.Configuration.SelectedOptions');
fixType(Itemization.Configuration.SelectedOptions);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions);
/**
 * SOURCE ItemVariationDetails @ squareup/bills/cart.proto at 1013:7
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails = $root.lookupType('squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails);
/**
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 1014:9
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails = $root.lookupType('squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails);
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 1025:9
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails = $root.lookupType('squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails);
/**
 * Details of the original catalog objects used to create this itemization
 * if they were represented as Merchant Catalog objects.
 *
 * IMPORTANT: The items v1 item variation should continue to be populated
 * until this note is removed.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 1036:11
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails.MerchantCatalogObjects');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails.MerchantCatalogObjects, {
  itemVariation: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails.MerchantCatalogObjects);
/**
 * Additional details for a gift card itemization.
 *
 * SOURCE GiftCardDetails @ squareup/bills/cart.proto at 1058:9
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails = $root.lookupType('squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails, {
  activityType: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails);
/**
 * Action taken on the gift card, e.g. balance reload, new activation, etc.
 *
 * SOURCE ActivityType @ squareup/bills/cart.proto at 1066:11
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType = $root.lookupEnum('squareup.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType').values;
/**
 * The backing data type used to create the itemization.
 *
 * SOURCE BackingType @ squareup/bills/cart.proto at 1148:5
 */
Itemization.Configuration.BackingType = $root.lookupEnum('squareup.bills.Itemization.Configuration.BackingType').values;
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 1186:3
 */
Itemization.BackingDetails = $root.lookupType('squareup.bills.Itemization.BackingDetails');
fixType(Itemization.BackingDetails);
Builder.createAndAttachToType(Itemization.BackingDetails);
/**
 * Details of the original catalog objects used to create this itemization
 * if they were represented as Merchant Catalog objects.
 *
 * IMPORTANT: The items v1 catalog objects should continue to be populated
 * until this note is removed.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 1202:5
 */
Itemization.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.Itemization.BackingDetails.MerchantCatalogObjects');
fixType(Itemization.BackingDetails.MerchantCatalogObjects, {
  item: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.BackingDetails.MerchantCatalogObjects);
/**
 * SOURCE AvailableOptions @ squareup/bills/cart.proto at 1213:5
 */
Itemization.BackingDetails.AvailableOptions = $root.lookupType('squareup.bills.Itemization.BackingDetails.AvailableOptions');
fixType(Itemization.BackingDetails.AvailableOptions);
Builder.createAndAttachToType(Itemization.BackingDetails.AvailableOptions);
/**
 * SOURCE ModifierList @ squareup/bills/cart.proto at 1217:7
 */
Itemization.BackingDetails.AvailableOptions.ModifierList = $root.lookupType('squareup.bills.Itemization.BackingDetails.AvailableOptions.ModifierList');
fixType(Itemization.BackingDetails.AvailableOptions.ModifierList);
Builder.createAndAttachToType(Itemization.BackingDetails.AvailableOptions.ModifierList);
/**
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 1244:3
 */
Itemization.DisplayDetails = $root.lookupType('squareup.bills.Itemization.DisplayDetails');
fixType(Itemization.DisplayDetails);
Builder.createAndAttachToType(Itemization.DisplayDetails);
/**
 * Details from the original item used to create the itemization.
 *
 * SOURCE Item @ squareup/bills/cart.proto at 1246:5
 */
Itemization.DisplayDetails.Item = $root.lookupType('squareup.bills.Itemization.DisplayDetails.Item');
fixType(Itemization.DisplayDetails.Item);
Builder.createAndAttachToType(Itemization.DisplayDetails.Item);
/**
 * SOURCE MenuCategory @ squareup/bills/cart.proto at 1257:7
 */
Itemization.DisplayDetails.Item.MenuCategory = $root.lookupType('squareup.bills.Itemization.DisplayDetails.Item.MenuCategory');
fixType(Itemization.DisplayDetails.Item.MenuCategory);
Builder.createAndAttachToType(Itemization.DisplayDetails.Item.MenuCategory);
/**
 * SOURCE Menu @ squareup/bills/cart.proto at 1264:7
 */
Itemization.DisplayDetails.Item.Menu = $root.lookupType('squareup.bills.Itemization.DisplayDetails.Item.Menu');
fixType(Itemization.DisplayDetails.Item.Menu);
Builder.createAndAttachToType(Itemization.DisplayDetails.Item.Menu);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 1280:3
 */
Itemization.Amounts = $root.lookupType('squareup.bills.Itemization.Amounts');
fixType(Itemization.Amounts);
Builder.createAndAttachToType(Itemization.Amounts);
/**
 * SOURCE ReportingAmounts @ squareup/bills/cart.proto at 1324:5
 */
Itemization.Amounts.ReportingAmounts = $root.lookupType('squareup.bills.Itemization.Amounts.ReportingAmounts');
fixType(Itemization.Amounts.ReportingAmounts);
Builder.createAndAttachToType(Itemization.Amounts.ReportingAmounts);
/**
 * SOURCE CostOfGoodsAmounts @ squareup/bills/cart.proto at 1325:7
 */
Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts = $root.lookupType('squareup.bills.Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts');
fixType(Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts);
Builder.createAndAttachToType(Itemization.Amounts.ReportingAmounts.CostOfGoodsAmounts);
/**
 * SOURCE VendorCostOfGoodsAmounts @ squareup/bills/cart.proto at 1352:7
 */
Itemization.Amounts.ReportingAmounts.VendorCostOfGoodsAmounts = $root.lookupType('squareup.bills.Itemization.Amounts.ReportingAmounts.VendorCostOfGoodsAmounts');
fixType(Itemization.Amounts.ReportingAmounts.VendorCostOfGoodsAmounts);
Builder.createAndAttachToType(Itemization.Amounts.ReportingAmounts.VendorCostOfGoodsAmounts);
/**
 * Units that tier_min and tier_max are in
 *
 * SOURCE TierUnit @ squareup/bills/cart.proto at 1415:7
 */
Itemization.Amounts.ReportingAmounts.TierUnit = $root.lookupEnum('squareup.bills.Itemization.Amounts.ReportingAmounts.TierUnit').values;
/**
 * SOURCE Event @ squareup/bills/cart.proto at 1473:3
 */
Itemization.Event = $root.lookupType('squareup.bills.Itemization.Event');
fixType(Itemization.Event, {
  eventTokenPair: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Event);
/**
 * Clients MUST be forward compatible with any new event types defined in the future,
 * that is, to handle unknown new event types gracefully without crashes.
 *
 * SOURCE EventType @ squareup/bills/cart.proto at 1480:5
 */
Itemization.Event.EventType = $root.lookupEnum('squareup.bills.Itemization.Event.EventType').values;
/**
 * An itemization split occurs when comping/voiding partial quantity of an
 * existing itemization or splitting/moving an itemization into another ticket.
 *
 * The child itemizations' Itemization.created_at should be set to the parent
 * splitting itemization's Itemization.created_at to preserve order in the list.
 *
 * SOURCE SplitEventDetails @ squareup/bills/cart.proto at 1596:5
 */
Itemization.Event.SplitEventDetails = $root.lookupType('squareup.bills.Itemization.Event.SplitEventDetails');
fixType(Itemization.Event.SplitEventDetails);
Builder.createAndAttachToType(Itemization.Event.SplitEventDetails);
/**
 * SOURCE ChildItemization @ squareup/bills/cart.proto at 1597:7
 */
Itemization.Event.SplitEventDetails.ChildItemization = $root.lookupType('squareup.bills.Itemization.Event.SplitEventDetails.ChildItemization');
fixType(Itemization.Event.SplitEventDetails.ChildItemization, {
  ticketTokenPair: {
    required: true
  },
  childItemizationTokenPair: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Event.SplitEventDetails.ChildItemization);
/**
 * A reference to an itemization on a different ticket.
 *
 * SOURCE ItemizationReference @ squareup/bills/cart.proto at 1617:6
 */
Itemization.Event.ItemizationReference = $root.lookupType('squareup.bills.Itemization.Event.ItemizationReference');
fixType(Itemization.Event.ItemizationReference, {
  ticketTokenPair: {
    required: true
  },
  itemizationTokenPair: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Event.ItemizationReference);
/**
 * SOURCE FeatureDetails @ squareup/bills/cart.proto at 1635:3
 */
Itemization.FeatureDetails = $root.lookupType('squareup.bills.Itemization.FeatureDetails');
fixType(Itemization.FeatureDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails);
/**
 * SOURCE Seating @ squareup/bills/cart.proto at 1642:5
 */
Itemization.FeatureDetails.Seating = $root.lookupType('squareup.bills.Itemization.FeatureDetails.Seating');
fixType(Itemization.FeatureDetails.Seating);
Builder.createAndAttachToType(Itemization.FeatureDetails.Seating);
/**
 * SOURCE Destination @ squareup/bills/cart.proto at 1643:7
 */
Itemization.FeatureDetails.Seating.Destination = $root.lookupType('squareup.bills.Itemization.FeatureDetails.Seating.Destination');
fixType(Itemization.FeatureDetails.Seating.Destination, {
  seatTokenPair: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.FeatureDetails.Seating.Destination);
/**
 * SOURCE Type @ squareup/bills/cart.proto at 1644:9
 */
Itemization.FeatureDetails.Seating.Destination.Type = $root.lookupEnum('squareup.bills.Itemization.FeatureDetails.Seating.Destination.Type').values;
/**
 * SOURCE AppointmentsServiceDetails @ squareup/bills/cart.proto at 1671:5
 */
Itemization.FeatureDetails.AppointmentsServiceDetails = $root.lookupType('squareup.bills.Itemization.FeatureDetails.AppointmentsServiceDetails');
fixType(Itemization.FeatureDetails.AppointmentsServiceDetails, {
  serviceId: {
    required: true
  },
  ordinal: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.FeatureDetails.AppointmentsServiceDetails);
/**
 * SOURCE ResourceDetails @ squareup/bills/cart.proto at 1696:7
 */
Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails = $root.lookupType('squareup.bills.Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails');
fixType(Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails);
/**
 * Metadata about an Itemization that was created from a previous itemization.
 * This should be populated whenever an itemization is created from another itemization (e.g. in a reopen or split).
 * Events should be copied in full, without modification, when an itemization is created from a previous itemization.
 *
 * SOURCE InheritedItemizationDetails @ squareup/bills/cart.proto at 1724:5
 */
Itemization.FeatureDetails.InheritedItemizationDetails = $root.lookupType('squareup.bills.Itemization.FeatureDetails.InheritedItemizationDetails');
fixType(Itemization.FeatureDetails.InheritedItemizationDetails, {
  inheritedEventTokenPairs: {
    required: true
  },
  createReason: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.FeatureDetails.InheritedItemizationDetails);
/**
 * Indicates what caused this itemization to be created.
 *
 * SOURCE CreateReason @ squareup/bills/cart.proto at 1732:7
 */
Itemization.FeatureDetails.InheritedItemizationDetails.CreateReason = $root.lookupEnum('squareup.bills.Itemization.FeatureDetails.InheritedItemizationDetails.CreateReason').values;
/**
 * Pricing engine state tied to an itemization.
 *
 * SOURCE PricingEngineState @ squareup/bills/cart.proto at 1747:5
 */
Itemization.FeatureDetails.PricingEngineState = $root.lookupType('squareup.bills.Itemization.FeatureDetails.PricingEngineState');
fixType(Itemization.FeatureDetails.PricingEngineState);
Builder.createAndAttachToType(Itemization.FeatureDetails.PricingEngineState);
/**
 * SOURCE SignInType @ squareup/bills/cart.proto at 1770:5
 */
Itemization.FeatureDetails.SignInType = $root.lookupEnum('squareup.bills.Itemization.FeatureDetails.SignInType').values;
/**
 * Extensions for item-splitting-specific features
 *
 * SOURCE LineItemSplitDetails @ squareup/bills/cart.proto at 1785:6
 */
Itemization.FeatureDetails.LineItemSplitDetails = $root.lookupType('squareup.bills.Itemization.FeatureDetails.LineItemSplitDetails');
fixType(Itemization.FeatureDetails.LineItemSplitDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails.LineItemSplitDetails);
/**
 * SOURCE LineItemPricing @ squareup/bills/cart.proto at 1795:7
 */
Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing = $root.lookupType('squareup.bills.Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing');
fixType(Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing);
Builder.createAndAttachToType(Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing);
/**
 * SOURCE EmployeeAttribution @ squareup/bills/cart.proto at 1825:3
 */
Itemization.EmployeeAttribution = $root.lookupType('squareup.bills.Itemization.EmployeeAttribution');
fixType(Itemization.EmployeeAttribution);
Builder.createAndAttachToType(Itemization.EmployeeAttribution);
/**
 * SOURCE DiscountLineItem @ squareup/bills/cart.proto at 1840:1
 */
export const DiscountLineItem = $root.lookupType('squareup.bills.DiscountLineItem');
fixType(DiscountLineItem);
Builder.createAndAttachToType(DiscountLineItem);
/**
 * SOURCE Configuration @ squareup/bills/cart.proto at 1851:3
 */
DiscountLineItem.Configuration = $root.lookupType('squareup.bills.DiscountLineItem.Configuration');
fixType(DiscountLineItem.Configuration);
Builder.createAndAttachToType(DiscountLineItem.Configuration);
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 1860:3
 */
DiscountLineItem.BackingDetails = $root.lookupType('squareup.bills.DiscountLineItem.BackingDetails');
fixType(DiscountLineItem.BackingDetails);
Builder.createAndAttachToType(DiscountLineItem.BackingDetails);
/**
 * Details of the original catalog objects used to create this discount line item
 * if they were represented as Merchant Catalog objects.
 *
 * IMPORTANT: The items v1 discount object should continue to be populated until this note is removed.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 1870:5
 */
DiscountLineItem.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.DiscountLineItem.BackingDetails.MerchantCatalogObjects');
fixType(DiscountLineItem.BackingDetails.MerchantCatalogObjects, {
  discount: {
    required: true
  }
});
Builder.createAndAttachToType(DiscountLineItem.BackingDetails.MerchantCatalogObjects);
/**
 * Some services (i.e. invoices, retail) want to reference discounts that
 * are not from the items service.
 * Note: when there are more than one coupon token, this field will not be populated.
 * `coupon_tokens` will be populated instead.
 *
 * SOURCE BackingType @ squareup/bills/cart.proto at 1890:5
 */
DiscountLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.bills.DiscountLineItem.BackingDetails.BackingType').values;
/**
 * Details from the original discount used to create the discount line item.
 *
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 1919:3
 */
DiscountLineItem.DisplayDetails = $root.lookupType('squareup.bills.DiscountLineItem.DisplayDetails');
fixType(DiscountLineItem.DisplayDetails);
Builder.createAndAttachToType(DiscountLineItem.DisplayDetails);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 1944:3
 */
DiscountLineItem.Amounts = $root.lookupType('squareup.bills.DiscountLineItem.Amounts');
fixType(DiscountLineItem.Amounts);
Builder.createAndAttachToType(DiscountLineItem.Amounts);
/**
 * This field tracks how a DiscountLineItem was added to the cart, whether by a person or by
 * matching a pricing rule.
 *
 * SOURCE ApplicationMethod @ squareup/bills/cart.proto at 1970:3
 */
DiscountLineItem.ApplicationMethod = $root.lookupEnum('squareup.bills.DiscountLineItem.ApplicationMethod').values;
/**
 * Discounts, fees, dining options can apply at either the cart-level or the itemization-level.
 * Adding this field to a LineItem allows us to have specific business logic for handling
 * different rules for cart level vs override fields.
 *
 * When deriving top level rollups, and a mixture of ITEMIZATION_LEVEL & CART_LEVEL exist,
 * the client should prefer CART_LEVEL in order to ensure that newly added itemizations will
 * also receive the line_item associated with this ApplicationScope.
 *
 * SOURCE ApplicationScope @ squareup/bills/cart.proto at 2011:1
 */
export const ApplicationScope = $root.lookupEnum('squareup.bills.ApplicationScope').values;
/**
 * SOURCE FeeLineItem @ squareup/bills/cart.proto at 2058:1
 */
export const FeeLineItem = $root.lookupType('squareup.bills.FeeLineItem');
fixType(FeeLineItem);
Builder.createAndAttachToType(FeeLineItem);
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 2069:3
 */
FeeLineItem.BackingDetails = $root.lookupType('squareup.bills.FeeLineItem.BackingDetails');
fixType(FeeLineItem.BackingDetails);
Builder.createAndAttachToType(FeeLineItem.BackingDetails);
/**
 * Details of the original catalog objects used to create this fee line item
 * if they were represented as Merchant Catalog objects.
 *
 * IMPORTANT: The items v1 fee object should continue to be populated until this note is removed.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 2083:5
 */
FeeLineItem.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.FeeLineItem.BackingDetails.MerchantCatalogObjects');
fixType(FeeLineItem.BackingDetails.MerchantCatalogObjects, {
  fee: {
    required: true
  }
});
Builder.createAndAttachToType(FeeLineItem.BackingDetails.MerchantCatalogObjects);
/**
 * Some services (i.e. retail, LST) reference fees that are not stored in the items service.
 * BackingType provides a way to differentiate these custom fees from those in the items service.
 *
 * SOURCE BackingType @ squareup/bills/cart.proto at 2099:5
 */
FeeLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.bills.FeeLineItem.BackingDetails.BackingType').values;
/**
 * Details from the original fee used to create the fee line item.
 *
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 2120:3
 */
FeeLineItem.DisplayDetails = $root.lookupType('squareup.bills.FeeLineItem.DisplayDetails');
fixType(FeeLineItem.DisplayDetails);
Builder.createAndAttachToType(FeeLineItem.DisplayDetails);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 2162:3
 */
FeeLineItem.Amounts = $root.lookupType('squareup.bills.FeeLineItem.Amounts');
fixType(FeeLineItem.Amounts);
Builder.createAndAttachToType(FeeLineItem.Amounts);
/**
 * Describes how the FeeLineItem was applied to the cart.
 *
 * SOURCE ApplicationMethod @ squareup/bills/cart.proto at 2209:3
 */
FeeLineItem.ApplicationMethod = $root.lookupEnum('squareup.bills.FeeLineItem.ApplicationMethod').values;
/**
 * TODO (k, kiran): ordinal for modifier options?
 *
 * SOURCE ModifierOptionLineItem @ squareup/bills/cart.proto at 2229:1
 */
export const ModifierOptionLineItem = $root.lookupType('squareup.bills.ModifierOptionLineItem');
fixType(ModifierOptionLineItem);
Builder.createAndAttachToType(ModifierOptionLineItem);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 2230:3
 */
ModifierOptionLineItem.Amounts = $root.lookupType('squareup.bills.ModifierOptionLineItem.Amounts');
fixType(ModifierOptionLineItem.Amounts);
Builder.createAndAttachToType(ModifierOptionLineItem.Amounts);
/**
 * Details from the original modifier option used to create the modifier option line item.
 *
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 2248:3
 */
ModifierOptionLineItem.DisplayDetails = $root.lookupType('squareup.bills.ModifierOptionLineItem.DisplayDetails');
fixType(ModifierOptionLineItem.DisplayDetails);
Builder.createAndAttachToType(ModifierOptionLineItem.DisplayDetails);
/**
 * SOURCE ModifierList @ squareup/bills/cart.proto at 2254:5
 */
ModifierOptionLineItem.DisplayDetails.ModifierList = $root.lookupType('squareup.bills.ModifierOptionLineItem.DisplayDetails.ModifierList');
fixType(ModifierOptionLineItem.DisplayDetails.ModifierList);
Builder.createAndAttachToType(ModifierOptionLineItem.DisplayDetails.ModifierList);
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 2266:3
 */
ModifierOptionLineItem.BackingDetails = $root.lookupType('squareup.bills.ModifierOptionLineItem.BackingDetails');
fixType(ModifierOptionLineItem.BackingDetails);
Builder.createAndAttachToType(ModifierOptionLineItem.BackingDetails);
/**
 * Details of the original catalog objects used to create this modifier option line item
 * if they were represented as Merchant Catalog objects.
 *
 * IMPORTANT: The items v1 objects should continue to be populated until this note is removed.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 2278:5
 */
ModifierOptionLineItem.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.ModifierOptionLineItem.BackingDetails.MerchantCatalogObjects');
fixType(ModifierOptionLineItem.BackingDetails.MerchantCatalogObjects, {
  modifierOption: {
    required: true
  },
  modifierList: {
    required: true
  }
});
Builder.createAndAttachToType(ModifierOptionLineItem.BackingDetails.MerchantCatalogObjects);
/**
 * SOURCE BackingType @ squareup/bills/cart.proto at 2287:5
 */
ModifierOptionLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.bills.ModifierOptionLineItem.BackingDetails.BackingType').values;
/**
 * SOURCE FeatureDetails @ squareup/bills/cart.proto at 2312:3
 */
ModifierOptionLineItem.FeatureDetails = $root.lookupType('squareup.bills.ModifierOptionLineItem.FeatureDetails');
fixType(ModifierOptionLineItem.FeatureDetails);
Builder.createAndAttachToType(ModifierOptionLineItem.FeatureDetails);
/**
 * SOURCE ConversationalMode @ squareup/bills/cart.proto at 2313:5
 */
ModifierOptionLineItem.FeatureDetails.ConversationalMode = $root.lookupType('squareup.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode');
fixType(ModifierOptionLineItem.FeatureDetails.ConversationalMode);
Builder.createAndAttachToType(ModifierOptionLineItem.FeatureDetails.ConversationalMode);
/**
 * SOURCE Type @ squareup/bills/cart.proto at 2314:7
 */
ModifierOptionLineItem.FeatureDetails.ConversationalMode.Type = $root.lookupEnum('squareup.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode.Type').values;
/**
 * Quantity of the modifier on the itemization.
 * Current: Integer quantity. e.g. 0, 1, or 2
 * Future: Decimal quantity. e.g. 1.0 or 0.5 or 3.5
 *
 * SOURCE Quantities @ squareup/bills/cart.proto at 2339:5
 */
ModifierOptionLineItem.FeatureDetails.Quantities = $root.lookupType('squareup.bills.ModifierOptionLineItem.FeatureDetails.Quantities');
fixType(ModifierOptionLineItem.FeatureDetails.Quantities);
Builder.createAndAttachToType(ModifierOptionLineItem.FeatureDetails.Quantities);
/**
 * SOURCE RoundingAdjustmentLineItem @ squareup/bills/cart.proto at 2360:1
 */
export const RoundingAdjustmentLineItem = $root.lookupType('squareup.bills.RoundingAdjustmentLineItem');
fixType(RoundingAdjustmentLineItem);
Builder.createAndAttachToType(RoundingAdjustmentLineItem);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 2363:3
 */
RoundingAdjustmentLineItem.Amounts = $root.lookupType('squareup.bills.RoundingAdjustmentLineItem.Amounts');
fixType(RoundingAdjustmentLineItem.Amounts);
Builder.createAndAttachToType(RoundingAdjustmentLineItem.Amounts);
/**
 * SOURCE DiningOptionLineItem @ squareup/bills/cart.proto at 2380:1
 */
export const DiningOptionLineItem = $root.lookupType('squareup.bills.DiningOptionLineItem');
fixType(DiningOptionLineItem, {
  diningOptionLineItemTokenPair: {
    required: true
  },
  backingDetails: {
    required: true
  },
  applicationScope: {
    required: true
  }
});
Builder.createAndAttachToType(DiningOptionLineItem);
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 2384:3
 */
DiningOptionLineItem.BackingDetails = $root.lookupType('squareup.bills.DiningOptionLineItem.BackingDetails');
fixType(DiningOptionLineItem.BackingDetails, {
  diningOption: {
    required: true
  }
});
Builder.createAndAttachToType(DiningOptionLineItem.BackingDetails);
/**
 * Details of the original catalog objects used to create this dining option
 * line item if they were represented as Merchant Catalog objects.
 *
 * IMPORTANT: The items v1 dining option should continue to be populated until
 * this note is removed.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 2395:5
 */
DiningOptionLineItem.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.DiningOptionLineItem.BackingDetails.MerchantCatalogObjects');
fixType(DiningOptionLineItem.BackingDetails.MerchantCatalogObjects, {
  diningOption: {
    required: true
  }
});
Builder.createAndAttachToType(DiningOptionLineItem.BackingDetails.MerchantCatalogObjects);
/**
 * There's no TipLineItem in sales cart. It is represented implicitly in tender because tip is strongly tied to tender.
 * There's TipLineItem in return cart because there's no strong tie to a refund.
 *
 * SOURCE TipLineItem @ squareup/bills/cart.proto at 2415:1
 */
export const TipLineItem = $root.lookupType('squareup.bills.TipLineItem');
fixType(TipLineItem, {
  tipLineItemTokenPair: {
    required: true
  }
});
Builder.createAndAttachToType(TipLineItem);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 2419:3
 */
TipLineItem.Amounts = $root.lookupType('squareup.bills.TipLineItem.Amounts');
fixType(TipLineItem.Amounts, {
  appliedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(TipLineItem.Amounts);
/**
 * SOURCE SurchargeLineItem @ squareup/bills/cart.proto at 2429:1
 */
export const SurchargeLineItem = $root.lookupType('squareup.bills.SurchargeLineItem');
fixType(SurchargeLineItem);
Builder.createAndAttachToType(SurchargeLineItem);
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 2442:3
 */
SurchargeLineItem.BackingDetails = $root.lookupType('squareup.bills.SurchargeLineItem.BackingDetails');
fixType(SurchargeLineItem.BackingDetails);
Builder.createAndAttachToType(SurchargeLineItem.BackingDetails);
/**
 * Surcharges may be defined adhoc (i.e. CUSTOM) or by the items service.
 *
 * SOURCE BackingType @ squareup/bills/cart.proto at 2448:5
 */
SurchargeLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.bills.SurchargeLineItem.BackingDetails.BackingType').values;
/**
 * Details of the original catalog objects used to create this surcharge
 * if they were represented as Merchant Catalog objects.
 *
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 2462:5
 */
SurchargeLineItem.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.SurchargeLineItem.BackingDetails.MerchantCatalogObjects');
fixType(SurchargeLineItem.BackingDetails.MerchantCatalogObjects, {
  surcharge: {
    required: true
  }
});
Builder.createAndAttachToType(SurchargeLineItem.BackingDetails.MerchantCatalogObjects);
/**
 * SOURCE Amounts @ squareup/bills/cart.proto at 2474:3
 */
SurchargeLineItem.Amounts = $root.lookupType('squareup.bills.SurchargeLineItem.Amounts');
fixType(SurchargeLineItem.Amounts);
Builder.createAndAttachToType(SurchargeLineItem.Amounts);
/**
 * Pricing engine state tied to a SurchargeLineItem.
 *
 * SOURCE PricingEngineState @ squareup/bills/cart.proto at 2488:3
 */
SurchargeLineItem.PricingEngineState = $root.lookupType('squareup.bills.SurchargeLineItem.PricingEngineState');
fixType(SurchargeLineItem.PricingEngineState);
Builder.createAndAttachToType(SurchargeLineItem.PricingEngineState);
/**
 * How the apportioned surcharge was applied to the cart.
 *
 * SOURCE ApplicationMethod @ squareup/bills/cart.proto at 2527:3
 */
SurchargeLineItem.ApplicationMethod = $root.lookupEnum('squareup.bills.SurchargeLineItem.ApplicationMethod').values;
/**
 * SOURCE GroupLineItem @ squareup/bills/cart.proto at 2555:1
 */
export const GroupLineItem = $root.lookupType('squareup.bills.GroupLineItem');
fixType(GroupLineItem);
Builder.createAndAttachToType(GroupLineItem);
/**
 * SOURCE Configuration @ squareup/bills/cart.proto at 2559:3
 */
GroupLineItem.Configuration = $root.lookupType('squareup.bills.GroupLineItem.Configuration');
fixType(GroupLineItem.Configuration);
Builder.createAndAttachToType(GroupLineItem.Configuration);
/**
 * SOURCE ComboConfiguration @ squareup/bills/cart.proto at 2560:5
 */
GroupLineItem.Configuration.ComboConfiguration = $root.lookupType('squareup.bills.GroupLineItem.Configuration.ComboConfiguration');
fixType(GroupLineItem.Configuration.ComboConfiguration);
Builder.createAndAttachToType(GroupLineItem.Configuration.ComboConfiguration);
/**
 * SOURCE ItemizationGroup @ squareup/bills/cart.proto at 2571:1
 */
export const ItemizationGroup = $root.lookupType('squareup.bills.ItemizationGroup');
fixType(ItemizationGroup);
Builder.createAndAttachToType(ItemizationGroup);
/**
 * SOURCE Type @ squareup/bills/cart.proto at 2575:3
 */
ItemizationGroup.Type = $root.lookupEnum('squareup.bills.ItemizationGroup.Type').values;
/**
 * SOURCE BackingDetails @ squareup/bills/cart.proto at 2582:3
 */
ItemizationGroup.BackingDetails = $root.lookupType('squareup.bills.ItemizationGroup.BackingDetails');
fixType(ItemizationGroup.BackingDetails);
Builder.createAndAttachToType(ItemizationGroup.BackingDetails);
/**
 * SOURCE MerchantCatalogObjects @ squareup/bills/cart.proto at 2586:5
 */
ItemizationGroup.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.bills.ItemizationGroup.BackingDetails.MerchantCatalogObjects');
fixType(ItemizationGroup.BackingDetails.MerchantCatalogObjects);
Builder.createAndAttachToType(ItemizationGroup.BackingDetails.MerchantCatalogObjects);
/**
 * SOURCE DisplayDetails @ squareup/bills/cart.proto at 2594:3
 */
ItemizationGroup.DisplayDetails = $root.lookupType('squareup.bills.ItemizationGroup.DisplayDetails');
fixType(ItemizationGroup.DisplayDetails);
Builder.createAndAttachToType(ItemizationGroup.DisplayDetails);
/**
 * SOURCE ComboChoice @ squareup/bills/cart.proto at 2599:5
 */
ItemizationGroup.DisplayDetails.ComboChoice = $root.lookupType('squareup.bills.ItemizationGroup.DisplayDetails.ComboChoice');
fixType(ItemizationGroup.DisplayDetails.ComboChoice);
Builder.createAndAttachToType(ItemizationGroup.DisplayDetails.ComboChoice);
/**
 * SOURCE ValidationDetails @ squareup/bills/cart.proto at 2604:7
 */
ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails = $root.lookupType('squareup.bills.ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails');
fixType(ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails);
Builder.createAndAttachToType(ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails);
/**
 * There's no TipLineItem in sales cart. It is represented implicitly in tender because tip is strongly tied to tender.
 * There's TipLineItem in return cart because there's no strong tie to a refund.
 *
 * SOURCE ReturnTipLineItem @ squareup/bills/cart.proto at 2622:1
 */
export const ReturnTipLineItem = $root.lookupType('squareup.bills.ReturnTipLineItem');
fixType(ReturnTipLineItem);
Builder.createAndAttachToType(ReturnTipLineItem);
/**
 * SOURCE ReturnSurchargeLineItem @ squareup/bills/cart.proto at 2633:1
 */
export const ReturnSurchargeLineItem = $root.lookupType('squareup.bills.ReturnSurchargeLineItem');
fixType(ReturnSurchargeLineItem);
Builder.createAndAttachToType(ReturnSurchargeLineItem);